import { Component, ErrorInfo, ReactNode } from 'react';

// 窗口级错误边界：某个 APP 出问题不能把整个壳层一起拖死。
// 该组件渲染在 WindowFrame 的内容区域内。
interface Props {
  children: ReactNode;
  fallback?: (error: Error) => ReactNode;
}

interface State {
  error: Error | null;
}

export class WindowErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[WindowErrorBoundary] APP crashed', error, info);
  }

  override render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error);
      return (
        <div className="p-4 text-sm text-danger">
          <p className="font-semibold">APP 渲染失败</p>
          <pre className="whitespace-pre-wrap">{this.state.error.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
